








import { Component, Vue } from "vue-property-decorator";
import { Tabbar, TabbarItem } from "vant";
import { env } from "@/env";
@Component({
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
  },
})
export default class WeTabBar extends Vue {
  private active: number = 2;
  private activeColor: string = env.VUE_APP_COLOR as string;
}
